// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodBenchmarkId } from './FoodBenchmark';
import { foodAllergenId } from './FoodAllergen';
import { z } from 'zod';
export const foodBenchmarkAllergenId = (z.number());
export const foodBenchmarkAllergen = z.object({
    id: foodBenchmarkAllergenId,
    benchmark_id: foodBenchmarkId,
    allergen_id: foodAllergenId,
});
export const foodBenchmarkAllergenInitializer = z.object({
    id: foodBenchmarkAllergenId.optional(),
    benchmark_id: foodBenchmarkId,
    allergen_id: foodAllergenId,
});
export const foodBenchmarkAllergenMutator = z.object({
    id: foodBenchmarkAllergenId.optional(),
    benchmark_id: foodBenchmarkId.optional(),
    allergen_id: foodAllergenId.optional(),
});
//# sourceMappingURL=FoodBenchmarkAllergen.js.map